/**
 * @author Mustafa Omran <promustafaomran@hotmail.com>
 */
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'moLoop', pure: false })
export class MOloop implements PipeTransform {
    transform(value: any, args?: any[]): any[] {
        if (value) {
            let keys: any[] = Object.keys(value),
                values = [];
            keys.forEach((key: any) => {
                values.push(value[key]);
            });
            return values;
        }
    }
}


// WEBPACK FOOTER //
// /opt/build/repo/src/app/MartMax/pipes/mo-loop.pipe.ts